import { get, post } from "../common/query";
export const GET_ADDRESSLIST = data => get("/takeover/get", data);
export const DEL_ADDRESS = data => post("/takeover/del", data);
export const EDIT_ADDRESS = data => post("/takeover/edit", data);
export const SET_DEFAULT_ADDRESS = data => post("/takeover/setd", data);
